import {Injectable} from '@angular/core';
import {MatSnackBar, MatSnackBarConfig, MatSnackBarRef} from '@angular/material';

@Injectable()
export class SnackService {

    constructor(private snackBar: MatSnackBar) {
    }

    showSnack(message: string, config: MatSnackBarConfig = null) {
        if (config === null) {
            config = new MatSnackBarConfig();
        }

        config.duration = 3000;
        const ref: MatSnackBarRef<any> = this.snackBar.open(message, null, config);
    }

    showSuccess(message: string) {
        const config = new MatSnackBarConfig();
        config.panelClass = ['success'];
        this.showSnack(message, config);
    }

    showWarn(message: string) {
        const config = new MatSnackBarConfig();
        config.panelClass = ['warn'];
        this.showSnack(message, config);
    }

    showSnackWithAction(message: string, action: string, actionCallback: () => void) {
        const ref: MatSnackBarRef<any> = this.snackBar.open(message, action, {
            duration: 3000,
        });

        ref.onAction().subscribe(actionCallback);
    }
}



// WEBPACK FOOTER //
// /app/src/services/snack.service.ts